import { DatePicker, Form, Input, message, Select } from "antd";
import React, { useEffect, useRef, useState } from "react";
import rpmService from "../../../../../Services/rpmService";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPatMappedRpmDevList,
  fetchRpmDevicesList,
  setSelectedRpmPatient,
} from "../../../../../Redux/actions/rpmActions";
import { convertUTCDate } from "../../../../../utils/convertionFunc";

function AddDevices({ handleClose }) {
  const [loader, setLoader] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const formRef = useRef();
  const { devicesList, selectedRpmPatient } = useSelector((state) => state.rpm);
  const dispatch = useDispatch();
  const loggedUserObj = sessionStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;
  const connectivityOptions = [
    { name: "Manual", value: "Manual" },
    { name: "Bluetooth", value: "Bluetooth" },
  ];

  useEffect(() => {
    const payload = {
      status: 1,
    };
    dispatch(fetchRpmDevicesList(payload));
  }, []);

  useEffect(() => {
    if (!selectedRpmPatient) {
      const rpmPatientJson = sessionStorage.getItem("rpmPatient");
      const rpmPatientObject = rpmPatientJson
        ? JSON.parse(rpmPatientJson)
        : null;
      if (rpmPatientObject) dispatch(setSelectedRpmPatient(rpmPatientObject));
    }
  }, []);

  const handleDevicePatientMap = async () => {
    const {
      brand,
      deviceCode,
      deviceDemo,
      connectivity,
      issuedDate,
      model,
      serialNumber,
      serviceFrom,
      serviceTo,
    } = formRef.current.getFieldValue();

    if (
      !brand ||
      !deviceCode ||
      !deviceDemo ||
      !connectivity ||
      !issuedDate ||
      !model ||
      !serialNumber ||
      !serviceFrom ||
      !serviceTo
    ) {
      message.error("Please fill in mandatory fields");
      return;
    }

    setLoader(true);
    const payload = {
      deviceCode,
      brand,
      model,
      serialNumber,
      connectivity,
      issuedDate: convertUTCDate(issuedDate, "YYYY-MM-DD HH:mm:ss"),
      deviceDemo,
      serviceFrom: convertUTCDate(serviceFrom, "MM/DD/YYYY"),
      serviceTo: convertUTCDate(serviceTo, "MM/DD/YYYY"),
      name: selectedDevice.name,
      createdBy: loggedUser?.user?.userId,
      // cptCode: "99454",
      patientCode: selectedRpmPatient.patientId,
      deliveredOn: convertUTCDate(serviceFrom, "MM/DD/YYYY"),
    };

    try {
      await rpmService.devicePatientMapping(payload);
      setLoader(false);
      const mappedDevicePayload = {
        patientCode: selectedRpmPatient.patientId,
        status: 1,
      };
      dispatch(fetchPatMappedRpmDevList(mappedDevicePayload));
      handleClose();
    } catch (e) {
      console.error(e);
      setLoader(false);
    }
  };

  const handleSelectedDevice = (deviceCode) => {
    const item = devicesList.find((d) => d.code === deviceCode);
    if (!item) return;

    setSelectedDevice(item);
    formRef.current.setFieldsValue({
      brand: item.brand,
      model: item.model,
      serialNumber: item.serialNumber,
    });
  };
  return (
    <>
      <Form layout="vertical" ref={formRef} disabled={loader}>
        <div className="grid grid-cols-2 items-center gap-4">
          <div>
            <Form.Item
              label={
                <span>
                  Devices <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="deviceCode"
            >
              <Select
                placeholder="Select"
                style={{
                  width: "100%",
                }}
                onChange={handleSelectedDevice}
                options={devicesList.map((item, idx) => {
                  return {
                    label: item.name,
                    value: item.code,
                    key: idx,
                  };
                })}
              />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Brand <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="brand"
            >
              <Input placeholder="Enter" />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Model <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="model"
            >
              <Input placeholder="Enter" />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Serial No <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="serialNumber"
            >
              <Input placeholder="Enter" />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Connectivity <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="connectivity"
            >
              <Select
                placeholder="Select"
                style={{
                  width: "100%",
                }}
                options={connectivityOptions.map((item, idx) => {
                  return {
                    label: item.name,
                    value: item.value,
                    key: idx,
                  };
                })}
              />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Issued Date <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="issuedDate"
            >
              <DatePicker
                style={{ width: "100%" }}
                placeholder="Select"
                format="MM-DD-YYYY"
              />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Demo Given? <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="deviceDemo"
            >
              <Select
                placeholder="Select"
                style={{
                  width: "100%",
                }}
                options={["Yes", "No"].map((item, idx) => {
                  return {
                    label: item,
                    value: item,
                    key: idx,
                  };
                })}
              />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Service From <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="serviceFrom"
            >
              <DatePicker
                style={{ width: "100%" }}
                placeholder="Select"
                format="MM-DD-YYYY"
              />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Service To <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="serviceTo"
            >
              <DatePicker
                style={{ width: "100%" }}
                placeholder="Select"
                format="MM-DD-YYYY"
              />
            </Form.Item>
          </div>
        </div>
      </Form>
      <div className="flex items-center w-full justify-end my-5">
        <button
          onClick={handleClose}
          className="border-brand-primaryColor bg-white border rounded text-brand-primaryColor text-sm px-6 py-1"
        >
          Cancel
        </button>
        <button
          disabled={loader}
          onClick={handleDevicePatientMap}
          className="bg-brand-primaryColor text-white border-brand-primaryColor border rounded px-5 py-1 text-brand-textWhite text-sm ml-3 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Submit
        </button>
      </div>
    </>
  );
}

export default AddDevices;
